import { useEffect, useState } from "react";
import { useWidgetStore } from "../../stores";
import { getCookie, setCookie } from "../../utils";
import { Item } from "../../types/widget";

const usePermanentWidgets = (): void => {
  const items = useWidgetStore((s) => s.items);
  const addItem = useWidgetStore((s) => s.addItem);
  const addWidgetToItem = useWidgetStore((s) => s.addWidgetToItem);

  const [initialLoad, setInitialLoad] = useState<boolean>(true);

  useEffect(() => {
    if (items.length) return;

    const rawCookie = getCookie("dashItems");
    if (!rawCookie) return;

    const parsedItems = JSON.parse(rawCookie);

    (parsedItems as Item[]).forEach((item) => {
      let { id } = addItem([]);

      item.widgets.forEach((widget) => {
        addWidgetToItem(widget.name, id, widget.flex);
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (initialLoad) return setInitialLoad(false);

    setCookie("dashItems", JSON.stringify(items));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);
};

export default usePermanentWidgets;
